/**
 * For maintainability we should separate controllers into their own modules
 */
angular.module('acme.view.application.programs.modals.scheduleChangedModal.controllers', [])

.controller('ProgramsModalsScheduleChangedModalController', ['$scope', '$uibModalInstance', 'currentEvent', 'emailSetting', function($scope, $uibModalInstance, currentEvent, emailSetting) {

    $scope.programsModalsScheduleChangedModal = {

      model: {},

      notificationEmail: true,
      notificationType: 'always',
      notificationList: [],
      notificationHideList: true,

      init: function() {
        this.model = currentEvent;
        this.setNotificationList();

        this.notificationType = emailSetting;
      },

      setNotificationList: function() {
        var self = $scope.programsModalsScheduleChangedModal;
        angular.forEach(this.model.resources, function(item, index) {
          if (item.resourceCategory === 'Personnel' &&
              item.resourceName &&
              item.resourceName.length) {
            self.notificationList.push(item.resourceName);
          }
        });
      },

      checkNotification: function() {
        if (this.notificationType === 'never') {
          this.notificationEmail = false;
        }

        this.model.sendEmail = this.notificationEmail;
      },

      close: function() {
        $uibModalInstance.dismiss('cancel');
      },

      done: function() {
        this.checkNotification();
        $uibModalInstance.close(this.notificationEmail);
      },

      success: {
        init: function(response) {}
      },

      error: {
        init: function(response) {}
      }

    };

    $scope.programsModalsScheduleChangedModal.init();

}]);